import { User } from '@frontend/data-access';
import { UserAvatar } from '@frontend/shared/ui';

import { getOrdinal } from './top-contributors';

function TopCard({
  index,
  user,
  me,
  point,
}: {
  index: number;
  user: User;
  me: number | undefined;
  point: string | number;
}) {
  const getBgColor = () => {
    switch (index) {
      case 1:
        return 'bg-yellow-400';
      case 2:
        return 'bg-[#CFD7E6]';
      case 3:
        return 'bg-[#E29662]';
      default:
        return 'bg-gray-300';
    }
  };

  const getBorderColor = () => {
    switch (index) {
      case 1:
        return 'border-yellow-400';
      case 2:
        return 'border-gray-500/80';
      case 3:
        return 'border-gray-500/80';
      default:
        return 'border-gray-400';
    }
  };

  return (
    <div
      className={`relative rounded-2xl bg-white py-4 px-5 border ${getBorderColor()} flex flex-col`}
    >
      <div className="flex flex-col flex-grow">
        <div
          className={`absolute top-0 right-7 w-10 p-2 rounded-b-xl text-center ${getBgColor()} text-white font-medium`}
        >
          <div className="text-lg font-medium text-black/60">
            {index}
            <span className="text-[10px]">{getOrdinal(index)}</span>
          </div>
        </div>

        <div className="space-y-2 mb-4">
          <UserAvatar user={user} size={64} showBadge badgeSize={32} />
          <div className="space-y-0">
            <div className="text-lg text-gray-1000 font-medium">
              {user.fullName}
              {me === user.id && <span className="ml-1">(You)</span>}
            </div>
            <div className="text-sm">{user.profile?.title}</div>
          </div>
        </div>

        <div className="grid grid-cols-[1f_auto_1fr] items-center gap-4 mt-auto">
          <div className="space-y-0">
            <div className="font-light text-sm">Points</div>
            <div className="text-2xl">{point}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopCard;
